import Header from "../components/Authentication/Header";
import ResetPassword from "../components/Authentication/ResetPassword";

const ResetPasswordPage = () => {
  return (
    <>
      <Header title="Reset your password" />
      <ResetPassword />
    </>
  );
};

export default ResetPasswordPage;
